import React from 'react'

interface CaseIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const CaseIcon: React.FC<CaseIconProps> = ({
  color = '#000',
  gradient,
  width = 24,
  height = 20,
  alt = 'Folder icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 24 20'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M9.377 1.389c.14.091.252.223.325.38l.78 1.691c.218.472.554.869.97 1.146.415.277.894.423 1.383.422h8.54c.232 0 .455.1.619.276a.984.984 0 01.256.668v11.334c0 .25-.092.49-.256.667a.844.844 0 01-.619.277H2.125a.844.844 0 01-.619-.277.984.984 0 01-.256-.667V2.194c0-.25.092-.49.256-.667a.844.844 0 01.619-.277h6.79a.827.827 0 01.462.139zM2.125 0h6.786c.415-.002.815.121 1.155.345.34.224.602.538.77.896l.002.005.174.379h10.971c.364 0 .733.115 1.023.348.293.237.494.59.494.995v14.338c0 .552-.203 1.1-.59 1.517-.39.42-.94.677-1.535.677H2.125a2.093 2.093 0 01-1.536-.677A2.234 2.234 0 010 17.306V2.194c0-.552.202-1.1.59-1.517C.98.257 1.53 0 2.124 0zM22.25 3.972v-.995a.124.124 0 00-.028-.03.39.39 0 00-.239-.072H11.588l.028.06c.126.272.313.487.528.63.215.143.453.213.688.213h8.543c.31 0 .606.069.875.194z'
        clipRule='evenodd'
      ></path>
    </svg>
  )
}

export default CaseIcon
